import React from 'react';
import {
  ArcButton,
  ArcContent,
  ArcSkeleton,
  ArcStack,
  ArcText,
  ArcToolbar,
} from '@src/core/ui';
import { ArcDrone } from '@src/core/components';

import { useSelectDrone } from './useSelectDrone';

const SelectDroneSidebar: React.FC = () => {
  const {
    drones,
    selected,
    isLoading,
    isCanceling,
    hasDrones,
    onSelectDrone,
    goForth,
    goBack,
    onCancel,
    onExit,
    onMouseEnter,
    onMouseLeave,
  } = useSelectDrone();

  if (isLoading) {
    return (
      <ArcStack spacing={1}>
        <ArcSkeleton width="100%" height={70} />
        <ArcSkeleton width="100%" height={70} />
        <ArcSkeleton width="100%" height={70} />
      </ArcStack>
    );
  }

  if (!hasDrones) {
    return (
      <ArcContent>
        <ArcText.h5 textAlign="center">No drone</ArcText.h5>
      </ArcContent>
    );
  }

  return (
    <ArcStack pb={1} spacing={2} height="100%">
      <ArcToolbar title="2. Select drone" goBack={goBack} />

      <ArcStack spacing={2} height="100%" justifyContent="space-between">
        {/* Drone List */}
        <ArcStack spacing={1} sx={{ overflowY: 'auto' }}>
          {drones.map((drone) => (
            <ArcDrone.primary
              key={drone.id}
              drone={drone}
              selected={drone.id === selected?.id}
              onClick={() => onSelectDrone(drone)}
              onMouseEnter={() => onMouseEnter(drone)}
              onMouseLeave={onMouseLeave}
            />
          ))}
        </ArcStack>

        {/* Actions */}
        <ArcStack spacing={1}>
          <ArcStack spacing={1} direction="row">
            <ArcButton.ghost fullWidth isLoading={isCanceling} onClick={onCancel}>
              Cancel
            </ArcButton.ghost>
            <ArcButton.ghost fullWidth onClick={onExit}>
              Exit
            </ArcButton.ghost>
          </ArcStack>
          <ArcButton.brand fullWidth onClick={goForth}>
            Next
          </ArcButton.brand>
        </ArcStack>
      </ArcStack>
    </ArcStack>
  );
};

export default SelectDroneSidebar;